// The mascot's contract (UI plan §2.2). THE HARD RULE, in the type system:
// the mascot responds to LOGGING, never to what was logged. There is no pose
// and no message context for "over target", "under-ate", "disappointed" or
// any other food judgement — if the variant doesn't exist here, no one can
// write copy for it by accident. tests/shared/mascot.test.ts enforces this.

export const MASCOT_POSES = [
  "idle",
  "greeting", //       onboarding welcome
  "thinking", //       while an AI estimate runs
  "celebrating", //    logging milestones ONLY (a logged day, a first week)
  "explaining", //     check-ins, target changes
  "welcoming-back", // return after absence — warm, never mentions the gap
  "sleeping", //       night hours / empty states
  "peeking", //        hands over eyes — password fields; privacy as delight
  // The assistant's four. Deliberately FOUR, not a hundred: a character is
  // recognised by a small repeatable set, and every pose here must still pass
  // the no-judgement contract — note "sheepish" (Cal sorry about its OWN
  // limits) rather than "sad" (Cal reacting to the user's data, forbidden).
  "talking", //        while an answer streams in
  "curious", //        listening while the user types
  "happy", //          calm joy — a good answer landed; not the confetti pose
  "sheepish", //       "that one's outside what I can help with"
] as const;

export type MascotPose = (typeof MASCOT_POSES)[number];

/** Message contexts → locale keys. Copy lives in the locale files only. */
export const mascotMessages = {
  welcome: "mascot.welcome",
  explaining_target: "adjust.explain_title",
  welcome_back: "mascot.welcome_back",
  door_login: "auth.mascot_login",
  door_signup: "auth.mascot_register",
} as const satisfies Record<string, string>;

const LAST_OPEN_KEY = "caloly.last_open";
const GAP_DAYS = 7;

/** Records this open and reports whether the user returned after a long gap.
 *  The gap length itself is deliberately not returned — the welcome-back
 *  moment never references how long someone was away. */
export function checkWelcomeBack(now = Date.now()): boolean {
  let cameBack = false;
  try {
    const last = Number(localStorage.getItem(LAST_OPEN_KEY));
    cameBack = Number.isFinite(last) && last > 0 && now - last > GAP_DAYS * 86400_000;
    localStorage.setItem(LAST_OPEN_KEY, String(now));
  } catch { /* storage unavailable */ }
  return cameBack;
}
